import { api } from '@/utils/api';

export const useDetailQuoteOrder = ({ transactionId }: { transactionId: string }) => {
    return api.platoUser.grid.getDetailQuoteOrder.get.useQuery(
        {
            id: transactionId,
        },
        {
            refetchOnMount: false,
        },
    );
};
